export const formatAsCurrency = (value, hideZeroDecimals) => {
  if (value != null) {
    const text = value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

    if (hideZeroDecimals && value % 1 === 0) {
      return text.substring(0, text.length - 3);
    } else {
      return text;
    }
  }

  return "";
};
